import { Card, Spin } from 'antd'
import React, { memo, useState, useEffect, useCallback, useMemo, forwardRef } from 'react'
import styles from './index.module.less'
import clsx from 'clsx'
import { BreadHeight, BreadOpen, SPACING_MODULE_INNER } from '@/config/theme'

// const style: React.CSSProperties = {
//   width: '100%',
// }

interface Props {
  children: React.ReactNode
  loading?: boolean
  className?: string
  style?: React.CSSProperties
  noPadding?: boolean; // 控制是否禁用 padding
}
// dashboard 主区域容器组件，默认有padding 16px
const BgContainer = forwardRef<HTMLDivElement, Props>(({ children, loading, className, style, noPadding = false, }, ref) => {
  // const style: React.CSSProperties = useMemo(() => {
  //   const breadHeight = BreadOpen ? `${BreadHeight}px` : 0
  //   return {
  //     height: `calc(100vh - 64px - 16px - 16px  - ${breadHeight})`,
  //     width: '100%',
  //   }
  // }, [])

  // console.log("style", style)

  // 动态计算样式
  // const containerStyle = useMemo(() => {
  //   // const breadHeight = BreadOpen ? `${BreadHeight}px` : '0px';
  //   const newStyle={...style,}

  //   if(noPadding){
  //     newStyle.padding = 0
  //   }
  //   return {
  //     // height: `calc(100vh - 64px - 16px - 16px - ${breadHeight})`,
  //     padding: noPadding ? 0 : SPACING_MODULE_INNER, // 默认 16px
  //   };
  // }, [style, noPadding]);

  return (
    <div className={clsx(styles['container'], className)} style={style} ref={ref}>
      {children}
      <div className={clsx(loading ? '' : 'z-index--1', styles['spin'])}>
        <Spin spinning={loading}> </Spin>
      </div>
    </div>
  )
})

export default BgContainer
